import store from './index';
export default {
  store: store,
  install: function install(Vue) {
    var vueInstance = Vue;
    vueInstance.prototype.$store = store();
  }
};